import color from '../themes/tradeRev/constants/colors';

export enum TagContent {
  isAsIs = 'isAsIs',
  noClosing = 'noClosing',
  inStock = 'inStock',
  numDisclosures = 'numDisclosures',
  chatNumber = 'chatNumber'
}

// TODO Revisit use
export const TagStyle = {
  default: color.BLACK,
  danger: color.RED
} as const;
